var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'theme_' + _vm.theme,style:({
  '--font': _vm.isApple
    ? "'Myriad', 'Bogle', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'"
    : 'Myriad',
  '--btnColor': 'linear-gradient(287deg, #050A72 -2%, #416AF1 96%)',
  '--nav-background':'#1A2B9E',
  '--newbtnColor':'linear-gradient(287deg, #050A72 -2%, #416AF1 96%)',
  '--bgImg':("url(" + (_vm.$img('/bg.png')) + ")"),
  '--userBg':("url(" + (_vm.$img('/user_bg.png')) + ")")
}),attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }